
import { COMMON_CHUNK_NAME } from '../../../../../const/generator';

import {
    BuilderComponentPlugin,
    BuilderComponentPluginFactory,
    ChunkType,
    FileType,
    ICodeStruct,
    IRouterInfo,
} from '../../../../../types';

const pluginFactory: BuilderComponentPluginFactory<unknown> = () => {
    const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
        const next: ICodeStruct = {
            ...pre,
        };

        const ir = next.ir as IRouterInfo;

        next.chunks.push({
            type: ChunkType.STRING,
            fileType: FileType.JS,
            name: COMMON_CHUNK_NAME.InternalDepsImport,
            content: `
        import {RollbackOutlined,AppstoreOutlined} from "@ant-design/icons";
      `,
            linkAfter: [COMMON_CHUNK_NAME.ExternalDepsImport],
        });

        next.chunks.push({
            type: ChunkType.STRING,
            fileType: FileType.JS,
            name: COMMON_CHUNK_NAME.FileExport,
            content: `
export const menuData = [{

    key: 'backIndex',
    name: '返回',
    icon: RollbackOutlined,
    to: "/"
},${ir.routes
                .map(
                    (route) => `
                    {
                      key:${route.componentName},
                      name: '${route.fileName}',
                      component: ${route.componentName},
                      icon: AppstoreOutlined,
                      to: "${route.path}"
                    }
                  `,
                )
                .join(',')}
];
      `,
            linkAfter: [
                COMMON_CHUNK_NAME.ExternalDepsImport,
                COMMON_CHUNK_NAME.InternalDepsImport,
                COMMON_CHUNK_NAME.ImportAliasDefine,
                COMMON_CHUNK_NAME.FileUtilDefine,
            ],
        });
        return next;
    };
    return plugin;
};

export default pluginFactory;
